/**
 * Feedback Queries
 */
import gql from 'graphql-tag'

export const getFeedbackQuery = gql`
  query getFeedback($userId: String!) {
    items: getFeedback(userId: $userId) {
      id
      feedbackId: feedback_id
      profileOwner: profile_owner
      name
      shortDescription: short_description
      thumbnail
      fitPreference: fit_preference
      genderRec: gender_rec
      sizeRec: size_rec
      styleRec: style_rec
      lengthName: length_name
      lengthRec: length_rec
    }
  }
`

export const submitFeedbackTicketMutation = gql`
  mutation submitFeedbackTicket(
    $ticketId: Int!,
    $score: Float!,
    $nps: Float!,
    $note: String,
    $feed: String,
    $questions: String,
    $items: [FeedbackItemInput],
    $files: [String]
  ) {
    result: submitFeedbackTicket(
      ticketId: $ticketId
      score: $score
      nps: $nps
      note: $note
      feed: $feed
      questions: $questions
      items: $items
      files: $files
    ) {
      message
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Feedback/data.ts